import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingFallback: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '300px',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingFallback;
